/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullInterventionDefinitionViewModel } from './FullInterventionDefinitionViewModel'; 

export function getFullInterventionDefinitionOptions(id: string, onSuccess?: (result: FullInterventionDefinitionViewModel) => void) {
	return queryOptions({
		queryKey: ['full-intervention-definition', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/getfullinterventiondefinition/' + id;
			const resp = await axios.get<FullInterventionDefinitionViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}